import { render } from "./AddToCartDetail.vue?vue&type=template&id=2f26bde7"
import script from "./AddToCartDetail.vue?vue&type=script&lang=js"
export * from "./AddToCartDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__